import { Col } from "reactstrap";
import { H5 } from "../../../../AbstractElements";
import { AdditiveRadiusTitle } from "../../../../Constants/Constants";
import { AdditiveRadiusData } from "../../../../Data/UiKits/HelperClasses";

const AdditiveRadius = () => {
  return (
    <Col xl="4" sm="12">
      <div className="border-wrapper h-100 border">
        <H5 className="mb-3">{AdditiveRadiusTitle}</H5>
        {AdditiveRadiusData &&
          AdditiveRadiusData.map((item, index) => (
            <div className="helper-common-box" key={index}>
              <div className={`helper-radius radius-wrapper ${item}`} />
              <span>{`.${item}`}</span>
            </div>
          ))}
      </div>
    </Col>
  );
};
export default AdditiveRadius;
